import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router';
import ServiceProvider from './serviceProvider';
import Terms from './terms';
import { CompanyProvider, useCompanyFromRoute } from './useCompany';

// Tudo o que fica sob /realEstate passa por aqui, com ou sem o companyId na
// frente (/#/<companyId>/realEstate/... ou /#/realEstate/...). A empresa é
// resolvida uma vez e chega às telas pelo useCompany(); uma tela nova só precisa
// entrar neste Switch. As rotas usam match.path, então herdam o :companyId.
function RealEstate({ match }) {
  const company = useCompanyFromRoute(match);

  // O Header global (logo da ZIP) e renderizado em todas as rotas; esta classe
  // de body o esconde e aplica o fundo da pagina.
  useEffect(() => {
    document.body.classList.add('real-estate-service-provider-page');

    return () => {
      document.body.classList.remove('real-estate-service-provider-page');
    };
  }, []);

  return (
    <CompanyProvider value={company}>
      <Switch>
        <Route path={`${match.path}/serviceProvider`} component={ServiceProvider} />
        <Route path={`${match.path}/termos/:slug`} component={Terms} />
      </Switch>
    </CompanyProvider>
  );
}

export default RealEstate;
